import React, { useState } from 'react';
import Tool, { type ToolButtonComponent } from './Tool';
import { ApplicationView } from '@aha-app/mvc';
import ToolButton from '../toolbars/ToolButton';
import layoutEnable from '../assets/icons/layoutEnable.svg';
import { svgToIcon } from '../utils/svg';

// Configure all of the layout settings.
class ToolLayoutEnable extends Tool {
  static toolName = 'Auto layout';

  static iconSVG = layoutEnable;

  static buttonComponent() {
    const Button: ToolButtonComponent = ApplicationView(
      ({ selection, tool, controller }) => {
        const [active, setActive] = useState(
          selection.firstObject().get('layoutEnabled')
        );

        return (
          <ToolButton
            active={active}
            tool={tool}
            onClick={() => {
              setActive(!active);
              selection.setOnObjects('layoutEnabled', !active, false);
              controller.actionRerenderToolbar();
              Tool.toolActionComplete({ controller });
            }}
          >
            {svgToIcon(this.iconSVG)}
          </ToolButton>
        );
      }
    );

    return Button;
  }
}

export default ToolLayoutEnable;
